import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../selectors';
import QuizVisualization from './QuizVisualization.component';

const QuizVisualizationContainer = props => <QuizVisualization {...props} />;

const mapStateToProps = (state, ownProps) => ({
	isLoading: apiSelectors.quiz.isLoadingSelector(state),
	status: apiSelectors.quiz.statusSelector(state),
	enabled: apiSelectors.quiz.enabledSelector(state),
	questionResultsVisualization: apiSelectors.quiz.questionResultsVisualizationSelector(state),
	user: apiSelectors.auth.userSelector(state),
	config: apiSelectors.config.configSelector(state),
	locale: appSelectors.locale.localeSelector(state),
	theming: appSelectors.ui.themingSelector(state),
});

const mapDispatchToProps = () => ({});

QuizVisualizationContainer.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(QuizVisualizationContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quizvisualization/QuizVisualization.container.js